import Input from "../../../../components/FormComponents/Input";

const OutlookConfig = ({ data, onChange }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onChange({ ...data, [name]: value });
  };

  return (
    <div className={"d_flex flex_column gap_3"}>
      <Input
        name="microsoft_tenant_id"
        value={data.microsoft_tenant_id}
        onChange={handleInputChange}
        placeholder="Enter Microsoft Tenant ID"
        label="Microsoft Tenant ID"
      />
      <Input
        name="microsoft_client_id"
        value={data.microsoft_client_id}
        onChange={handleInputChange}
        placeholder="Enter Microsoft Client ID"
        label="Microsoft Client ID"
      />
      <Input
        name="microsoft_client_secret"
        value={data.microsoft_client_secret}
        onChange={handleInputChange}
        placeholder="Enter Microsoft Client Secret"
        label="Microsoft Client Secret"
        type="password"
      />
      <Input
        name="microsoft_app_secret"
        value={data.microsoft_app_secret}
        onChange={handleInputChange}
        placeholder="Enter Microsoft App Secret"
        label="Microsoft App Secret"
        type="password"
      />
    </div>
  );
};
export default OutlookConfig;
